import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';
import Vant from 'vant';
import { Toast } from 'vant';
import 'vant/lib/index.css';
import '@/main.css';
require('@/gt.js');
Vue.prototype.$initGeet = initGeetest;

Vue.use(Vant);
Vue.use(Toast);

Vue.config.productionTip = false;

axios.defaults.baseURL = window.location.protocol
axios.interceptors.request.use(function (response) {
	if (sessionStorage.getItem('token')) {
		response.headers.Authorization = sessionStorage.getItem('token');
	}
	return response;
}, function (error) {
	Toast(error)
	return Promise.reject(error);
});

axios.interceptors.response.use((res) => {
	if (res.data.code == '10') {
		Toast("登录信息已失效，请重新登录");
		sessionStorage.setItem('loginBackcallUrl', window.location.pathname);
	}
	return res.data;
}, (err) => {
	Toast(err)
	return err;
});

router.beforeEach((to, from, next) => {
	var openId = sessionStorage.getItem('openId');
	if (to.meta.isLogin) {
		if (openId == null || openId == "" || openId == "null") {
			// 记录当前页面路由
			sessionStorage.setItem('loginBackcallUrl', to.fullPath);
			next("/login");
		} else {
			axios.interceptors.request.use(function (response) {
				response.headers.Authorization = sessionStorage.getItem('token');
				return response;
			}, function (error) {
				Toast(error)
				return Promise.reject(error);
			});
			next();
		}
	} else {
		next();
	}
});

/*手机屏幕自适应*/
var onresize = function () {
	var deviceWidth = document.documentElement.clientWidth;
	document.documentElement.style.fontSize = deviceWidth / 7.5 + 'px';
}
onresize();
window.onresize = onresize;
/*手机屏幕自适应*/
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js


// WEBPACK FOOTER //
// ./src/main.js